import { createListReducer } from 'Services/reducerCreator';

export default createListReducer('MERCATOSURVEY_LIST');
